import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthenticationService } from '../../../service/authentication.service';
import { Store } from '@ngrx/store';
import { UserState } from '../../../store/User/UserReducer';
import { Subscription } from 'rxjs';
import {
  initSelectedAccountSelector,
  initUserSelector,
} from '../../../store/User/UserSelector';
import { Role } from '../../../model/Role';
import { Logout } from '../../../store/User/UserActions';
import { DataexchangeService } from '../../../service/dataexchange.service';

@Component({
  selector: 'cw-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input()
  appVersion: string;

  activeNavigation: string;
  isCollapsed = true;
  isLoginPage: boolean;
  isReportPage: boolean;
  isAccountSelectionPage: boolean;
  isAccountInformationPage: boolean;
  isStatementsPage: boolean;
  isHeaderMenuVisible: boolean;
  role: Role;
  Role = Role;
  selectedAccount: string;

  private readonly subscriptions: Array<Subscription> =
    new Array<Subscription>();

  constructor(
    private readonly router: Router,
    private readonly userStore: Store<UserState>,
    private readonly dataexchangeService: DataexchangeService,
    private readonly authenticationService: AuthenticationService,
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.userStore.select(initUserSelector).subscribe((user) => {
        if (user) {
          this.role = user.userType;
        }
      }),
    );
    this.subscriptions.push(
      this.userStore
        .select(initSelectedAccountSelector)
        .subscribe((selectedAccount: string) => {
          this.selectedAccount = selectedAccount;
        }),
    );
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this.setRoutingVariables(event.urlAfterRedirects);
        this.setMenuIsVisible();
      } else if (event instanceof NavigationStart) {
        this.setRoutingVariables(event.url);
        this.setMenuIsVisible();
      }
    });
  }

  setRoutingVariables(url: string) {
    this.isStatementsPage = url.includes('statements');
    this.isAccountInformationPage = url.includes('account-information');
    this.isAccountSelectionPage = url.includes('account-selection');
    this.isReportPage = url.includes('report');
    this.isLoginPage = url === '/login';
  }

  setMenuIsVisible() {
    if (
      this.isAccountInformationPage ||
      this.isReportPage ||
      this.isStatementsPage
    ) {
      this.isHeaderMenuVisible = true;
    } else {
      this.isHeaderMenuVisible = false;
    }
  }

  async logout() {
    try {
      await this.authenticationService.logout();
      this.userStore.dispatch(new Logout());
      // Invalidated session cookies should be removed by the backend (sending proper response headers)
      this.dataexchangeService.resetObservablesToDefaultValue();
      this.router.navigateByUrl('login');
    } catch (err) {
      console.log(err);
    }
  }

  activateRoute(route: string) {
    this.activeNavigation = route;
  }
}
